export default __webpack_public_path__ + "static/media/lizard.340eec82.png";